import blocksModule from '../../blocks';
import { connectedStore } from '../../store';

const clearBlocksHtml = (blocks) => {
  const store = connectedStore.get();
  const state = store.getState();

  return blocks.map((block) => {
    const variations = blocksModule.selectors
      .getBlockVariations(state, block.id)
      .map((variation) => ({
        ...variation,
        html: '',
      }));

    return {
      ...block,
      variations,
      html: '',
    };
  });
};

export default clearBlocksHtml;
